import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useReducer, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PrimaryButton from '~/components/buttons/PrimaryButton';
import { setSessionItem } from '~/services/application.service';
import { getOfficerData, login } from '~/services/auth.service';
import { initAxios } from '~/services/http.service';
import { sleep } from '~/services/utilities.service';
import CountySelectionModal from './components/modals/CountySelectionModal';
import logo from '~/assets/images/logo-sm.png';
import { useAuth } from '~/hooks/useAuth';
const INITIATE_LOGIN = 'INITIATE_LOGIN';
const initialState = {
    counties: [],
    username: null,
    password: null,
    refreshToken: null,
    token: null,
};
const reducer = (state, action) => {
    switch (action.type) {
        case INITIATE_LOGIN: {
            return {
                ...state,
                ...action.payload,
            };
        }
        default:
            return state;
    }
};
const LoginScreen = () => {
    const navigate = useNavigate();
    const [authState, dispatch] = useAuth();
    const [state, screenDispatch] = useReducer(reducer, initialState);
    const [error, setError] = useState();
    const [showCountySelectionModal, setShowCountySelectionModal] = useState(false);
    const [processing, setProcessing] = useState(false);
    const [loginData, setLoginData] = useState({
        loginId: '',
        password: '',
    });
    const { loginId, password } = loginData;
    const changeHandler = (e) => {
        setLoginData({ ...loginData, [e.target.name]: e.target.value });
    };
    const submitHandler = async (e) => {
        e.preventDefault();
        setProcessing(true);
        const response = await login(loginData.loginId, loginData.password);
        if (response.error) {
            setError(response.error);
            setProcessing(false);
        }
        const { accessToken, refreshToken, counties, username } = response;
        initAxios(navigate);
        screenDispatch({
            type: 'INITIATE_LOGIN',
            payload: {
                counties,
                refreshToken,
                token: accessToken,
                username,
            },
        });
        setShowCountySelectionModal(true);
    };
    const setCounty = async (county) => {
        setShowCountySelectionModal(false);
        setSessionItem('county', county);
        const { firstName, lastName } = await getOfficerData(county, state.username);
        const user = {
            firstName,
            lastName,
        };
        await sleep(250);
        setSessionItem('user', JSON.stringify(user));
        dispatch({
            type: 'LOGIN',
            payload: {
                counties: state.counties,
                isAuthenticated: true,
                refreshToken: state.refreshToken,
                token: state.token,
                user,
            },
        });
    };
    useEffect(() => {
        if (authState.isAuthenticated) {
            navigate('/', { replace: true });
        }
    }, [authState.isAuthenticated]);
    return (_jsxs("div", { className: "flex h-screen w-screen items-center justify-center", style: {
            backgroundColor: '#e5e5f7',
        }, children: [_jsx("section", { children: _jsxs("form", { className: "rounded-md bg-white p-10 shadow-lg", children: [_jsx("div", { className: "mb-7 flex justify-center", children: _jsx("img", { alt: "Corrections Software Solutions", className: "w-[100px]", src: logo }) }), _jsxs("div", { className: "m-3 mb-5", children: [_jsx("label", { className: "mb-2 block text-gray-500", htmlFor: "login-id", children: "Login ID" }), _jsx("input", { className: "w-[300px] rounded-md border-gray-200", id: "login-id", name: "loginId", onChange: changeHandler, type: "text", value: loginId })] }), _jsxs("div", { className: "m-3", children: [_jsx("label", { className: "mb-2 block text-gray-500", htmlFor: "password", children: "Password" }), _jsx("input", { className: "w-[300px] rounded-md border-gray-200", id: "password", name: "password", onChange: changeHandler, type: "password", value: password })] }), error && (_jsxs("div", { className: "m-3 mt-10 flex justify-center text-red-500", children: ["Error: ", error] })), _jsx("div", { className: "m-3 mt-10 flex items-stretch justify-center", children: _jsx(PrimaryButton, { className: "grow", disabled: processing, onClick: submitHandler, text: "Submit", type: "submit" }) })] }) }), showCountySelectionModal && (_jsx(CountySelectionModal, { counties: state.counties, setCounty: setCounty }))] }));
};
export default LoginScreen;
